import React, { useState, useEffect } from 'react';
import type { IProps } from './plans-section-container';
import OutreachPlanCard from '../outreach-plan-card';
import {
  customBasePlanScaleMonthly,
  customBasePlanScaleQuarterly,
  customBasePlanScaleYearly,
  getCustomScalePlusPlanData,
  getOutreachPlanData,
} from './utils/helper';
import { getPlanMode } from '../../../select-plan/utils/helper';
import { isRequestPending } from '../../../../utils/helper';
import { BillingOption } from '../../../../../../../../shared/utils/billing-options';

const PlansSection: React.FC<IProps> = ({
  planCycle,
  onSelectPlan,
  selectedPlanId,
  //* API Request State
  sendGetPlansResponse,
  sendGetAccountSubscriptionResponse,
  sendPurchaseSubscriptionRequestStatus,
  sendGetPurchaseModifySubscriptionRequestStatus,
  isDemoAccount,

  onSchedule,
  isScheduleRequestLoading,
  isPaddlePolling,
}) => {
  const isPurchaseInProgress =
    isRequestPending(sendPurchaseSubscriptionRequestStatus) ||
    isRequestPending(sendGetPurchaseModifySubscriptionRequestStatus);

  //* states
  const [planData, setPlanData] = useState([]);
  const [customScalePlusPlans, setCustomScalePlusPlans] = useState([]);

  //* useEffect
  useEffect(() => {
    if (sendGetPlansResponse) {
      let customPlanData = {};

      if (planCycle === BillingOption.MONTHLY) {
        customPlanData = { ...customBasePlanScaleMonthly };
      } else if (planCycle === BillingOption.QUARTERLY) {
        customPlanData = { ...customBasePlanScaleQuarterly };
      } else if (planCycle === BillingOption.ANNUALLY) {
        customPlanData = { ...customBasePlanScaleYearly };
      }
      setPlanData([
        ...getOutreachPlanData(getPlanMode(planCycle), sendGetPlansResponse),
        customPlanData,
      ]);
      setCustomScalePlusPlans([
        ...getCustomScalePlusPlanData(
          getPlanMode(planCycle),
          sendGetPlansResponse,
        ),
      ]);
    }
  }, [planCycle, sendGetPlansResponse, sendGetAccountSubscriptionResponse]);

  return (
    <div className="d-flex justify-content-between align-items-end outreach-plans-card-container mt-4">
      {planData.map((plan) => (
        <OutreachPlanCard
          key={plan.id}
          plan={plan}
          customScalePlusPlans={customScalePlusPlans}
          planCycle={planCycle}
          handlePlanSelect={(planId, planName, counts) =>
            onSelectPlan(planId, planName, counts)
          }
          sendGetAccountSubscriptionResponse={
            sendGetAccountSubscriptionResponse
          }
          sendGetPlansResponse={sendGetPlansResponse}
          isPurchaseInProgress={
            (isPurchaseInProgress && selectedPlanId === plan.id) || isPaddlePolling
          }
          isDemoAccount={isDemoAccount}
          onSchedule={onSchedule}
          isScheduleRequestLoading={isScheduleRequestLoading}
        />
      ))}
    </div>
  );
};

export default PlansSection;
